"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTimeLateEvent = void 0;
const event_1 = require("./event");
class OneTimeLateEvent extends event_1.Event {
    constructor() {
        super(...arguments);
        this._triggeredWith = undefined;
        this._triggered = false;
    }
    trigger(data) {
        if (this._triggered) {
            return;
        }
        this._triggeredWith = data;
        this._triggered = true;
        super.trigger(data);
    }
    triggerAsync(data) {
        if (this._triggeredWith) {
            return Promise.resolve([]);
        }
        this._triggeredWith = data;
        this._triggered = true;
        return super.triggerAsync(data);
    }
    on(handler) {
        if (this._triggered) {
            handler(this._triggeredWith);
            return () => { };
        }
        return super.on(handler);
    }
}
exports.OneTimeLateEvent = OneTimeLateEvent;
//# sourceMappingURL=event.late.js.map